import React, { Component } from "react";
import styled from "styled-components";
import { oktaAuth } from "../oktaConfig";
import { RouteConstants } from "../constants/RouteConstants";
import mlbLogo from "../assets/mlb.png";

const SignInPage = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const SignInHeader = styled.header`
  height: 52px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: #041e42;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
`;

const HeaderLogo = styled.img`
  width: 45px;
  height: 26px;
  margin-right: 8px;
  object-fit: contain;
`;

const SignInHero = styled.main`
  min-height: calc(100vh - 52px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SignInPanel = styled.div`
  width: 342px;
  margin-top: -100px;
`;

const BrandLogo = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const SignInButton = styled.button`
  width: 100%;
  margin-top: 16px;
  padding: 7px 12px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  color: #363636;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: #b5b5b5;
  }

  &:focus {
    outline: 2px solid #2968f7;
    outline-offset: 2px;
  }
`;

class OktaRedirect extends Component {
  async componentDidMount() {
    if (this.isSignedOut()) {
      oktaAuth.tokenManager.clear();
      oktaAuth.removeOriginalUri();
      return;
    }

    await this.startSignIn();
  }

  isSignedOut = () => window.location.pathname === RouteConstants.SIGNED_OUT;

  startSignIn = async () => {
    const fallbackUri = this.isSignedOut()
      ? RouteConstants.BASE
      : `${RouteConstants.BASE}${window.location.search || ""}`;

    try {
      if (await oktaAuth.isAuthenticated()) {
        this.props.history.replace(oktaAuth.getOriginalUri() || fallbackUri);
        return;
      }
    } catch (error) {
      console.warn("Unable to verify the existing Status session", error);
    }

    if (!oktaAuth.getOriginalUri()) {
      oktaAuth.setOriginalUri(fallbackUri);
    }

    oktaAuth.signInWithRedirect().catch((error) => {
      console.error("Unable to redirect to MLB sign in", error);
    });
  };

  render() {
    if (!this.isSignedOut()) {
      return null;
    }

    return (
      <SignInPage>
        <SignInHeader>
          <HeaderLogo src={mlbLogo} alt="MLB" />
          Status Page
        </SignInHeader>
        <SignInHero>
          <SignInPanel>
            <BrandLogo src={mlbLogo} alt="MLB" />
            <SignInButton onClick={this.startSignIn}>
              Sign In with Okta
            </SignInButton>
          </SignInPanel>
        </SignInHero>
      </SignInPage>
    );
  }
}

export default OktaRedirect;
